import React from "react";
import CustomDropZone from "./CustomDropZone";
import axios from "axios";
import { awsUrl2, awsUrl } from "../../config";
import LoadingOverlay from "react-loading-overlay";
// import { Auth } from "aws-amplify";
import { GlobalAuthContext } from "../../context/AuthProvider";

const headingMap = {
  first: "Upload Loss Runs for Extraction or Manually Enter in the Below Table",
  second: "Upload Other Documents",
  third: "Upload Docs",
};

const folderMap = {
  first: "LossRun",
  second: "OtherDocuments",
  third: "UwDocs",
};

export default class DropZones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: this.props.fileList,
      uploadingInProgress: false,
      uploadMsg: undefined,
      uploadMsgSecond: undefined,
      errMsg: undefined,
      // Pibit state
      pibitUploading: false,
      pibitMsg: undefined,
      pibitErr: undefined,
    };
  }

  static contextType = GlobalAuthContext;

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(this.props.fileList) !== JSON.stringify(prevProps.fileList)
    ) {
      this.setState({ fileList: this.props.fileList });
    }
  }

  updateFileList = (name, newFile) => {
    let { fileList } = this.state;
    if (fileList[name][newFile.name] === "#empty") {
      this.setState({
        errMsg: "File already exist",
        uploadMsg: undefined,
        uploadMsgSecond: undefined,
        pibitMsg: undefined,
      });
      return;
    }
    fileList[name][newFile.name] = newFile;
    this.setState({
      fileList,
      errMsg: undefined,
      uploadMsg: undefined,
      uploadMsgSecond: undefined,
      pibitMsg: undefined,
    });
  };

  removeFile = (name, fileName) => {
    let { fileList } = this.state;
    delete fileList[name][fileName];
    this.setState({ fileList });
  };

  uploadFile = (fileData, postDataS3) => {
    return new Promise((resolve, reject) => {
      axios
        .post(awsUrl + "/api/uploadDocs", postDataS3)
        .then((response) => {
          let returnData = response.data;
          let lossSignedURL = returnData.lossSignedURL;
          let options = { header: { "Content-Type": postDataS3.fileType } };
          axios
            .put(lossSignedURL, fileData, options)
            .then((result) => {
              console.log("file upload res: ", result);
              resolve();
            })
            .catch((error) => {
              console.log("error in uploading", error);
              reject();
            });
        })
        .catch((error) => {
          console.log("error in uploadDocs ", error);
          reject();
        });
    });
  };

  updateLibertateUserStatusTable = (dataToSend) => {
    return new Promise((resolve, reject) => {
      axios
        .post(awsUrl2 + "/api/updateUserStatusTable", dataToSend)
        .then((res) => {
          resolve();
        })
        .catch((error) => {
          console.log("error in API-updateLibertateUserStatusTable", error);
          reject();
        });
    });
  };

  updateLibertateUserTable = (dataToSend) => {
    return new Promise((resolve, reject) => {
      axios
        .post(awsUrl2 + "/api/userTableData/update", dataToSend)
        .then((res) => {
          resolve();
        })
        .catch((err) => {
          console.log("Error:", err);
          reject();
        });
      console.log("inserted successfully in user table yay");
    });
  };

  toCamelCase = (str) => {
    if (!str) return "";
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  };

  sendLossRunSuccessEmail = async (currProspectDetails, user_id) => {
    try {
      const companyName =
        currProspectDetails?.companyProfile?.companyName?.value;
      const peoName = this.toCamelCase(
        currProspectDetails?.peoDetails?.selectedPeo,
      );

      let emailPeoName = "";

      if(peoName.toLowerCase() === "gms"){
          emailPeoName = "PEO1";
        } else if (peoName.toLowerCase() === "tee off temps"){
          emailPeoName = "PEO2";
        } else {
          emailPeoName = "Agent"
        }

      let req_obj = {
        to: [],
        cc: [],
        subject: `Loss Runs Uploaded - ${emailPeoName} - ${companyName}`,
        message: `Hi, \nLoss runs have been uploaded and submitted for extraction for ${companyName}. Please visit the portal to review the details.\n\nThanks\nInsureComp`,
      };

      if (process.env.REACT_APP_MODE === "prod") {
        req_obj.to = [
          "kevin.williams@accretive-ins.com",
          "jennifer.bush@ballator.com ",
          "workcomp@accretive-ins.com",
          "info.trigger@insurecomp.com",
          "Emily.Lacy@accretive-ins.com",
        ];
        req_obj.type = "aws";

        await axios
          .post(
            "https://n8pm5lcvtb.execute-api.us-east-1.amazonaws.com/prod/api/sendEmail",
            req_obj,
          )
          .then((res) => {
            console.log("Loss runs success email sent successfully");
          })
          .catch((err) => {
            console.log("Error in sending loss runs success email:", err);
          });
      } else {
        req_obj.to = ["info.trigger@insurecomp.com"];
        req_obj.bcc = [];
        req_obj.html = "";
        req_obj.files = [];
        await axios
          .post(
            "https://volfkpzl04.execute-api.us-east-1.amazonaws.com/beta/api/sendEmail",
            req_obj,
          )
          .then((res) => {
            console.log("Loss runs success email sent successfully");
          })
          .catch((err) => {
            console.log("Error in sending loss runs success email:", err);
          });
      }
    } catch (error) {
      console.log("Error in sending loss runs success email:", error);
    }
  };

  /**
   * Handles the S3 doc upload (existing logic) then calls
   * props.onContinuePibitCall for the "first" (loss run) bucket if provided.
   */
  handleUpload = async (uploadKey) => {
    let { updatePopUpData, fileKeyName, onContinuePibitCall } = this.props;
    let { user } = this.context;
    let { fileList } = this.state;

    let isLoggedIn = user;
    let loggedIn_emailID = isLoggedIn.attributes.email;

    const isLossRunUpload = uploadKey === "first";
    const existingLossRuns =
      isLossRunUpload &&
      fileList["first"] &&
      Object.values(fileList["first"]).some((v) => v === "#empty");

    updatePopUpData({
      show: true,
      title: 'Do you wish to continue?',
      children: (
        <>
          <br></br>
          <span style={{ fontWeight: "bold" }}>
            {existingLossRuns
              ? "Loss runs already exist for this submission. Uploading new loss runs will result in re-calculation of values and additional processing time and cost. Do you wish to upload again?"
              : "Files once uploaded cannot be deleted"}
          </span>
        </>
      ),
      acceptBtn: "Yes",
      acceptBtnCallback: async () => {
        try {
          let { fileList } = this.state;

          // Determine which keys to upload based on button clicked
          const keysToUpload = uploadKey ? [uploadKey] : Object.keys(fileList);
          const hasFiles = keysToUpload.some(
            (key) =>
              fileList[key] && Object.keys(fileList[key] ?? {}).length !== 0,
          );

          if (!hasFiles) {
            this.setState({ errMsg: "No files uploaded" });
            return;
          }

          let address = JSON.parse(sessionStorage.getItem("address"));
          let currProspectDetails = JSON.parse(
            sessionStorage.getItem("currProspect"),
          );
          let user_id = sessionStorage.getItem("user_id");
          let quoteData = JSON.parse(sessionStorage.getItem("quoteData"));
          let _sortKeyList = sessionStorage.getItem("sortKeyList");

          this.setState({
            uploadingInProgress: true,
            uploadMsgSecond: undefined,
            pibitMsg: undefined,
            uploadMsg: undefined,
          });

          const email = user_id;
          const folder1 = `${email}/${quoteData.uuid}_${quoteData.date}`;

          let promiseList = [],
            fileListToStore = [];
          let lossRunFiles = null; // collect first-bucket file objects for pibit

          for (let key of Object.keys(fileList)) {
            if (fileList[key]) {
              for (let fileName in fileList[key]) {
                let fileType = fileName.split(".").reverse()[0];
                const folder2 = folderMap[key];
                fileListToStore.push({
                  key: `${folder1}/${folder2}/${fileName}`,
                  fileType,
                  keyToFile: key,
                });

                const postDataS3 = {
                  folder1,
                  folder2,
                  fileName,
                  fileType,
                };

                // Only upload files for the clicked button that aren't already empty
                if (
                  keysToUpload.includes(key) &&
                  fileList[key][fileName] !== "#empty"
                ) {
                  // Collect loss run files for pibit
                  if (key === "first") {
                    if (!lossRunFiles) lossRunFiles = [];
                    lossRunFiles.push(fileList[key][fileName]);
                  }
                  promiseList.push(
                    this.uploadFile(fileList[key][fileName], postDataS3),
                  );
                }
              }
            }
          }

          Promise.all(promiseList)
            .then(async (res) => {
              let { fileList } = this.state;
              for (let key of keysToUpload) {
                if (fileList[key]) {
                  for (let fileName in fileList[key]) {
                    fileList[key][fileName] = "#empty";
                  }
                }
              }
              this.setState({ fileList });

              let req_body = {
                user_email_id: email,
                address: address,
                timestamp: quoteData.date,
                uuid: quoteData.uuid,
                peo: currProspectDetails.peoDetails.selectedPeo,
                [fileKeyName]: fileListToStore,
              };
              const fileListUserTable = [];
              for (let key in fileListToStore) {
                fileListUserTable.push(fileListToStore[key]["key"]);
              }
              let req_body_user_table = {
                user_email_id: email,
                address: address,
                uploadTimestamp: quoteData.date,
                [fileKeyName]: fileListUserTable,
              };

              this.updateLibertateUserStatusTable(req_body)
                .then(() => {
                  this.setState({ uploadingInProgress: false });
                  this.setState({
                    uploadMsg: this.props.isGetQuotes
                      ? undefined
                      : "Files uploaded successfully",
                    uploadMsgSecond:
                      uploadKey === "second" || !uploadKey
                        ? "Files uploaded successfully"
                        : this.state.uploadMsgSecond,
                    errMsg: undefined,
                  });
                })
                .catch((error) => console.log("error in API", error));

              this.updateLibertateUserTable(req_body_user_table)
                .then(() => {
                  this.setState({ uploadingInProgress: false });
                  this.setState({
                    uploadMsg: this.props.isGetQuotes
                      ? undefined
                      : "Files uploaded successfully",
                    uploadMsgSecond:
                      uploadKey === "second" || !uploadKey
                        ? "Files uploaded successfully"
                        : this.state.uploadMsgSecond,
                    errMsg: undefined,
                  });
                })
                .catch((error) => console.log("error in API", error));

              await axios.post(awsUrl + "/api/updateStatusDetails", {
                button_name: "upload_clicked",
                user_id: loggedIn_emailID,
                user_email_id: user_id,
                sortKeyList: JSON.parse(_sortKeyList),
              });

              // Pibit flow for loss run files
              if (
                uploadKey === "first" &&
                lossRunFiles &&
                lossRunFiles.length > 0 &&
                typeof onContinuePibitCall === "function"
              ) {
                this.setState({
                  pibitUploading: true,
                  pibitMsg: undefined,
                  pibitErr: undefined,
                });
                try {
                  const companyProfile = currProspectDetails?.companyProfile;
                  const pibitFileData = { file: lossRunFiles };
                  const data = { user_id, companyProfile };

                  const pibitResult = await onContinuePibitCall(
                    pibitFileData,
                    data,
                  );

                  if (pibitResult?.flag) {
                    this.setState({
                      pibitMsg:
                        "Loss runs submitted for extraction successfully",
                      pibitErr: undefined,
                    });
                    sessionStorage.setItem("uploadLossRun", "true");
                    await this.sendLossRunSuccessEmail(
                      currProspectDetails,
                      user_id,
                    );
                    updatePopUpData({
                      show: true,
                      title: "Do you wish to continue?",
                      children: (
                        <>
                          <br></br>
                          <span style={{ fontWeight: "bold" }}>
                            Loss Runs Uploaded Successfully for Extaction.
                            Redirect to dashboard?
                          </span>
                        </>
                      ),
                      acceptBtn: "Yes",
                      acceptBtnCallback: async () => {
                        try {
                          window.location.href = "./Dashboard";
                        } catch (error) {
                          console.log("error: ", error);
                        }
                      },
                    });
                  } else {
                    this.setState({
                      pibitErr:
                        "Loss runs uploaded but extraction failed. Please contact your administrator.",
                      pibitMsg: undefined,
                    });
                  }
                } catch (pibitError) {
                  console.log("Pibit call error:", pibitError);
                  this.setState({
                    pibitErr:
                      "Error during loss run extraction. Please contact your administrator.",
                    pibitMsg: undefined,
                  });
                } finally {
                  this.setState({ pibitUploading: false });
                }
              }

              try {
                let pibitPayload = {
                  user_email_id: user_id,
                  isLossRunsAvailable: true,
                };
                this.updateLibertateUserTable(pibitPayload);
              } catch (error) {
                console.log("error: ", error);
              }
              //
            })
            .catch((error) => {
              console.log("error: ", error);
              this.setState({ uploadingInProgress: false });
              this.setState({
                errMsg: "Upload failed. Please try again.",
                uploadMsg: undefined,
              });
            });
        } catch (error) {
          console.log("error: ", error);
        }
      },
    });
  };

  render() {
    let {
      fileList,
      uploadingInProgress,
      uploadMsg,
      errMsg,
      pibitUploading,
      pibitMsg,
      pibitErr,
    } = this.state;
    let { displayArray, isGetQuotes } = this.props;

    return (
      <LoadingOverlay active={uploadingInProgress || pibitUploading} spinner>
        <div className="dropZonesContainer">
          <div className="row mb-3 ">
            {displayArray[0] === true ? (
              <div className="col-sm-12 col-md-12 col-lg-6 uploadlossruns">
                <CustomDropZone
                  name="first"
                  fileList={fileList}
                  updateFileList={this.updateFileList}
                  removeFile={this.removeFile}
                  headingMap={headingMap}
                  uploadMsg={uploadMsg}
                  showSupportedFormats={isGetQuotes}
                />
                {isGetQuotes && (
                  <div className="d-flex justify-content-center mt-2">
                    <button
                      className="btn btn-warning btn-sm font-family-montserrat-regular"
                      style={{
                        width: "max-content",
                        color: "white",
                        backgroundColor: "#feae01",
                        boxShadow: "0px 5px 12px grey",
                        fontSize: "14px",
                        borderRadius: "10px",
                        fontWeight: "800",
                        fontFamily: "MontserratRegular",
                      }}
                      onClick={(event) => {
                        event.preventDefault();
                        this.handleUpload("first");
                      }}
                      disabled={
                        uploadingInProgress ||
                        pibitUploading ||
                        Object.values(fileList["first"] ?? {}).every(
                          (v) => v === "#empty",
                        )
                      }
                    >
                      {pibitUploading
                        ? "Extracting Loss Runs..."
                        : "Upload Loss Runs"}
                    </button>
                  </div>
                )}
                {/* Pibit feedback messages */}
                {pibitMsg && (
                  <div
                    className="text-center mt-1"
                    style={{ color: "green", fontSize: "13px" }}
                  >
                    {pibitMsg}
                  </div>
                )}
                {pibitErr && (
                  <div
                    className="text-center mt-1"
                    style={{ color: "red", fontSize: "13px" }}
                  >
                    {pibitErr}
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}
            {displayArray[1] === true ? (
              <div className="col-sm-12 col-md-12 col-lg-6">
                <CustomDropZone
                  name="second"
                  fileList={fileList}
                  updateFileList={this.updateFileList}
                  removeFile={this.removeFile}
                  headingMap={headingMap}
                  uploadMsg={uploadMsg}
                  extraTest={" (eg. Payroll registers)"}
                />
                {isGetQuotes && (
                  <div className="d-flex justify-content-center mt-2">
                    <button
                      className="btn btn-warning btn-sm font-family-montserrat-regular"
                      style={{
                        width: "max-content",
                        color: "white",
                        backgroundColor: "#feae01",
                        boxShadow: "0px 5px 12px grey",
                        fontSize: "14px",
                        borderRadius: "10px",
                        fontWeight: "800",
                        fontFamily: "MontserratRegular",
                      }}
                      onClick={(event) => {
                        event.preventDefault();
                        this.handleUpload("second");
                      }}
                      disabled={
                        uploadingInProgress ||
                        Object.values(fileList["second"] ?? {}).every(
                          (v) => v === "#empty",
                        )
                      }
                    >
                      Upload Other Documents
                    </button>
                  </div>
                )}
                {/* Other Documents feedback messages */}
                {this.state.uploadMsgSecond && (
                  <div
                    className="text-center mt-1"
                    style={{ color: "green", fontSize: "13px" }}
                  >
                    {this.state.uploadMsgSecond}
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}
            {displayArray[2] === true ? (
              <div className="col-sm-12 col-md-12 col-lg-12">
                <CustomDropZone
                  name="third"
                  fileList={fileList}
                  updateFileList={this.updateFileList}
                  removeFile={this.removeFile}
                  headingMap={headingMap}
                  uploadMsg={uploadMsg}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="d-flex flex-column">
            <pre
              className={
                "text-center text-capitalize " +
                (uploadMsg ? "text-success" : "text-danger")
              }
            >
              {uploadMsg || errMsg}
            </pre>
            {!isGetQuotes && (
              <button
                className="btn btn-warning btn-sm font-family-montserrat-regular "
                style={{
                  width: "min-content",
                  color: "white",
                  alignSelf: "center",
                  backgroundColor: "#feae01",
                  boxShadow: "0px 5px 12px grey",
                  fontSize: "16px",
                  borderRadius: "10px",
                  fontWeight: "800",
                  fontFamily: "MontserratRegular",
                  whiteSpace: "nowrap",
                }}
                onClick={(event) => {
                  event.preventDefault();
                  this.handleUpload();
                }}
                disabled={uploadingInProgress}
              >
                Upload
              </button>
            )}
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}
